import { ForgotPasswordForm as ForgotPasswordForm$1, Fields, Submit } from './ForgotPasswordForm.js';

const ForgotPasswordForm = Object.assign(ForgotPasswordForm$1, {
    Fields,
    Submit,
});

export { ForgotPasswordForm };
